import React from 'react';
//import "../../../assets/scss/components/app-loader.scss";
import Loader from 'react-loaders';
import './loader.scss';
class ComponentSpinner extends React.Component {
  render() {
    return (
      <div className="fallback-spinner vh-100 d-flex">
        {/*// className="fallback-spinner">*/}
        {/* <Loader
          style={{
            transform: "scale(1.1)",
            border: " 0 solid transparent",
            borderRadius: "10px",
            width: "100px",
            height: "100px",
          }}
          className="m-auto"
          type="square-spin"
          innerClassName="logop"
          //style={{ backgroundImage: 'url(/resto/logop.jpg)' }}
        ></Loader> */}
        <div className="loading component-loader">
          <div className="effect-1 effects"></div>
          <div className="effect-2 effects"></div>
          <div className="effect-3 effects"></div>
        </div>
      </div>
    );
  }
}

export default ComponentSpinner;
